<hx-dialog [title]="title()">
  <div hxDialogContent>
    <div class="hx-icon-picker__body">
      <div class="hx-icon-picker__search" [style.width]="searchBarWidth()">
        <span class="hx-icon-picker__search-icon">
          <hx-icon svgIcon="search" />
        </span>
        <input
          id="hx-icon-picker-search-bar"
          class="hx-icon-picker__search-input"
          type="search"
          [attr.aria-label]="searchPlaceholder()"
          [placeholder]="searchPlaceholder()"
          [value]="searchQuery()"
          (input)="onSearchInput($event)" />
      </div>

      <div class="hx-icon-picker__categories" role="list">
        @if (filteredCategories().length === 0) {
          <div class="hx-icon-picker__empty">{{ emptyStateText() }}</div>
        }

        @if (filteredCategories().length > 0) {
          <hx-accordion
            class="hx-icon-picker__accordion"
            [multi]="true"
            collapsedIcon="chevron-down"
            expandedIcon="chevron-down">
            @for (category of filteredCategories(); track category.name) {
              <hx-accordion-panel
                [expanded]="isCategoryExpanded(category.name)"
                (opened)="onCategoryOpened(category.name)"
                (closed)="onCategoryClosed(category.name)">
                <span hxAccordionHeader class="hx-icon-picker__category-title">{{ category.name }}</span>
                <div
                  hxAccordionContent
                  class="hx-icon-picker__icon-grid"
                  role="listbox"
                  [attr.aria-label]="category.name + ' icons'">
                  @if (isCategoryExpanded(category.name)) {
                    @for (icon of category.icons; track $index) {
                      <button
                        class="hx-icon-picker__icon-item"
                        type="button"
                        role="option"
                        [attr.aria-label]="'Select ' + icon.name"
                        [attr.aria-selected]="isSelected(icon.name)"
                        [class.hx-icon-picker__icon-item--selected]="isSelected(icon.name)"
                        (click)="selectIcon(icon.name)">
                        <span class="hx-icon-picker__icon-preview">
                          <hx-icon [svgIcon]="icon.name" />
                        </span>
                        <span class="hx-icon-picker__icon-label">{{ icon.name }}</span>
                      </button>
                    }
                  }
                </div>
              </hx-accordion-panel>
            }
          </hx-accordion>
        }
      </div>
    </div>
  </div>

  <div hxDialogActions>
    <button
      class="hx-icon-picker__footer-button"
      hxButton
      type="button"
      variant="outline"
      context="neutral"
      (click)="cancelSelection()">
      Cancel
    </button>
    <button
      class="hx-icon-picker__footer-button"
      hxButton
      type="button"
      variant="fill"
      context="brand"
      (click)="confirmSelection()">
      OK
    </button>
  </div>
</hx-dialog>
